// extracted by mini-css-extract-plugin
module.exports = {"form":"Checkout_form__1Odbu","control":"Checkout_control__Zcr1-","actions":"Checkout_actions__Jmkzo","submit":"Checkout_submit__1vVES","invalid":"Checkout_invalid__2d3Yc"};